import { isTgeSoon, useStakingContext } from '../../../contexts/StakingContext'
import { H2, P } from '../../../shared_components/Library/Typeography'
import { MaxWidth } from '../../../shared_components/Page'
import { ThemedButton } from '../../../shared_components/ThemedButton'
import { Box } from '../../../shared_components/UI/Box'
import { StakingTarget } from '../types'
import BenefitsOptions from './BenefitsOptions'
import ConnectWalletButton from '../../../shared_components/Library/Buttons/ConnectWalletButton'
import useIsLoggedIn from '../../../hooks/useIsLoggedIn'
import { isValid } from 'date-fns'

function StakingBenefits({
  target,
  scrollToStake,
}: {
  target: StakingTarget
  scrollToStake: () => void
}) {
  const { tokenApy, calculateBonusApy } = useStakingContext()
  const { isLoggedIn } = useIsLoggedIn()

  const isVaults = target === 'vaults'

  return (
    <MaxWidth maxWidth={1104}>
      <Box dc padV="section" g="var(--Index-Grids-Gutters, 32px)" c>
        <Box dc c g={20}>
          <H2 s="3XL" fw="bolder" uc c="text-primary" ff="Proxima Nova" tac>
            Your staking benefits
          </H2>
          <Box dc c g={12}>
            <P s="L" fw="regular" c="text-primary" tac>
              {' '}
              Access to exclusive XP Multipliers & Missions on ZAP Drops
            </P>
            <P s="L" fw="regular" c="text-primary" tac>
              Access to exclusive Private Sales on ZAP Labs
            </P>
            <P s="L" fw="regular" c="text-primary" tac>
              Share in reserved tokens supply from memecoins on ZAP Launch
            </P>
          </Box>
        </Box>
        <BenefitsOptions
          highlightedOption={12}
          options={[
            {
              value: 3,
              header: '3 Months',
              items: [
                {
                  title: 'Share of Airdrops',
                  description: 'of ZAP Labs airdrops',
                },
                {
                  title: 'Share of ZAP Labs Raises',
                  description:
                    target === 'tokens'
                      ? 'from dilution of ZAP Labs raises'
                      : 'of protected tokens',
                },
              ],
              // apy: isTgeSoon ? 'TBC' : `${getStakeTierApy(stakeInformation, 0)}%`,
              // multiplier: isTgeSoon && target === 'vaults' ? 'TBC' : target === 'vaults' ? '1.1x' : undefined,
              apy: `${isVaults ? (tokenApy[0] + calculateBonusApy(0)).toFixed(2) : tokenApy[0]}%`,
              multiplier: target === 'vaults' ? '1.1x' : undefined,
            },
            {
              value: 12,
              header: '12 Months',
              items: [
                {
                  title: '6x Share of Airdrops',
                  description: 'of ZAP Labs airdrops',
                },
                {
                  title: '6x Share of ZAP Labs Raises',
                  description:
                    target === 'tokens'
                      ? 'from dilution of ZAP Labs raises'
                      : 'of protected tokens',
                },
              ],
              // apy: isTgeSoon ? 'TBC' : `${getStakeTierApy(stakeInformation, 2)}%`,
              // multiplier: isTgeSoon && target === 'vaults' ? 'TBC' : target === 'vaults' ? '1.5x' : undefined,
              apy: `${isVaults ? (tokenApy[2] + calculateBonusApy(2)).toFixed(2) : tokenApy[2]}%`,
              multiplier: target === 'vaults' ? '1.5x' : undefined,
            },
            {
              value: 6,
              header: '6 Months',
              items: [
                {
                  title: '3x Share of Airdrops',
                  description: 'of ZAP Labs airdrops',
                },
                {
                  title: '3x Share of ZAP Labs Raises',
                  description:
                    target === 'tokens'
                      ? 'from dilution of ZAP Labs raises'
                      : 'of protected tokens',
                },
              ],
              // apy: isTgeSoon ? 'TBC' : `${getStakeTierApy(stakeInformation, 1)}%`,
              // multiplier: isTgeSoon ? 'TBC' : target === 'vaults' ? '1.3x' : undefined,
              apy: `${isVaults ? (tokenApy[1] + calculateBonusApy(1)).toFixed(2) : tokenApy[1]}%`,
              multiplier: target === 'vaults' ? '1.3x' : undefined,
            },
          ]}
        />
        {isLoggedIn ? (
          <ThemedButton
            $styleType="primary"
            onClick={scrollToStake}
            disabled={isTgeSoon}
          >
            {isTgeSoon ? 'Staking coming soon' : 'Stake now!'}
          </ThemedButton>
        ) : (
          <ConnectWalletButton />
        )}
      </Box>
    </MaxWidth>
  )
}

export default StakingBenefits
